import Give_WC_Donation_Form from './give-wc-form';
import { CustomEvent } from '../modules/give-wc-helpers';

// Initial load.
document.addEventListener("DOMContentLoaded", function () {

	// IE event supports.
	if (typeof window.CustomEvent !== "function") {
		CustomEvent.prototype = window.Event.prototype;
		window.CustomEvent = CustomEvent;
	}

	new Give_WC_Donation_Form();
});



// WEBPACK FOOTER //
// ./assets/src/js/frontend/give-wc-frontend.js